<template>
  <tr
    class="clickable"
    style="height: 90px"
    :class="{
      'red lighten-4': serviceTask.request_status === serviceTaskClass.REQUEST_STATUS_DENIED,
      'amber lighten-4': serviceTask.request_status === serviceTaskClass.REQUEST_STATUS_PENDING
    }"
  >
    <td
      v-if="$can('do-batch-actions', 'ServiceTask')"
      style="width: 1%"
      class="pr-0"
    >
      <v-checkbox
        :input-value="selected"
        primary
        hide-details
        class="ma-0"
        @click.stop="select(!selected)"
      />
    </td>
    <td style="width: 1%">
      <yacht-chip
        :name="serviceTask.yacht.name"
        :image-path="serviceTask.yacht.model.main_image ? serviceTask.yacht.model.main_image.path : null"
      />
    </td>
    <td>
      <div style="max-width: 350px">
        <div class="body-2 text-truncate">
          {{ serviceTask.title }}
        </div>
        <div
          class="text-uppercase grey--text caption mb-1"
        >
          <span>
            #{{ serviceTask.id }} &middot;
          </span>
          <span>
            {{ categoryData[serviceTask.category] }}
          </span>
          <span
            v-if="serviceTask.priority"
            class="pl-2"
          >
            <v-avatar
              size="10px"
              :color="priorityData[serviceTask.priority].color"
              class="mr-1"
            />
            {{ priorityData[serviceTask.priority].label }}
          </span>
          <v-chip
            v-if="serviceTask.is_warranty_claim"
            label
            x-small
            outlined
            class="ml-2 text-none"
            text-color="grey darken-2"
          >
            Warranty:
            <span
              v-if="serviceTask.warranty_claim_resolution === null"
              class="ml-1"
            >
              Pending
            </span>
            <span
              v-else-if="serviceTask.warranty_claim_resolution === true"
              class="success--text ml-1"
            >
              Accepted
            </span>
            <span
              v-else
              class="error--text ml-1"
            >
              Rejected
            </span>
          </v-chip>
        </div>
        <div class="grey--text text-truncate">
          {{ serviceTask.description }}
        </div>
      </div>
    </td>
    <td
      v-if="finishedView"
    >
      <div v-if="firstAssignee">
        <v-chip
          small
          outlined
          color="grey darken-2"
          class="ma-0"
        >
          <v-icon
            class="mr-1"
            style="font-size: 14px"
          >
            {{ assigneeTypeData[firstAssignee.type].icon }}
          </v-icon>
          {{ firstAssignee.name }}
        </v-chip>
        <span
          v-if="restAssigneesCount"
          class="grey--text"
        >
          and {{ restAssigneesCount }} more
        </span>
      </div>
    </td>
    <td v-if="!finishedView">
      <v-chip
        v-if="serviceTask.created_by"
        small
        outlined
        color="grey darken-2"
        class="ma-0"
      >
        <v-icon
          class="mr-1"
          style="font-size: 14px"
        >
          {{ assigneeTypeData['staff'].icon }}
        </v-icon>
        {{ serviceTask.created_by.name }}
      </v-chip>
      <span
        v-else
        class="grey--text"
      >
        n/a
      </span>
    </td>
    <td v-if="!finishedView">
      <span v-if="serviceTask.created_at">
        {{ serviceTask.created_at | moment('D MMM YYYY') }}
      </span>
      <span
        v-else
        class="grey--text"
      >
        n/a
      </span>
    </td>
    <td v-if="finishedView">
      <span v-if="serviceTask.finished && serviceTask.finished_at">
        {{ serviceTask.finished_at | moment('D MMM YYYY') }}
      </span>
      <span
        v-else
        class="grey--text"
      >
        n/a
      </span>
    </td>
    <td
      v-if="finishedView"
      class="text-center"
    >
      <span v-if="serviceTask.total_hours_spent">
        {{ serviceTask.total_hours_spent }}
      </span>
      <span
        v-else
        class="grey--text"
      >
        n/a
      </span>
    </td>
  </tr>
</template>

<script>
import ServiceTask from '@/models/ServiceTask'
import YachtChip from '@/components/service/helpers/YachtChip'

export default {
    name: 'ServiceTaskRow',
    components: { YachtChip },
    props: {
      serviceTask: {
        type: Object,
        default: null
      },
      selected: {
        type: Boolean,
        default: false
      },
      select: {
        type: Function,
        required: true
      },
      finishedView: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selectedDirty: {
        get: function () {
          return this.selected
        },
        set: function (val) {
          this.$emit('update:selected', val)
        }
      },
      serviceTaskClass() {
        return ServiceTask
      },
      firstAssignee() {
        if (!this.serviceTask.assigned_to || this.serviceTask.assigned_to.length === 0) return null

        return this.serviceTask.assigned_to[0]
      },
      restAssigneesCount() {
        if (!this.firstAssignee) return null

        return this.serviceTask.assigned_to.length - 1
      }
    },
    created() {
      this.assigneeTypeData = ServiceTask.assigneeTypeData
      let categoryData = { }

      for (let cat of ServiceTask.categoryData) {
        categoryData[cat.key] = cat.label
      }

      this.categoryData = categoryData

      this.priorityData = ServiceTask.priorityData
    }
  }
</script>
